import axios from 'axios';

export default {
  uploadSignedUrl(signedUrl, file) {
    let options = {
      headers: {
        'Content-Type': file.type
      }
    };
    
    return axios.put(signedUrl, file, options);
  }
}
